import { Button } from "@shared/components/ui/button";
import { Link } from "react-router-dom";

export default function NotFound({ code, message }) {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-background">
      <h1 className="text-4xl font-bold mb-4">{code} - Page Not Found</h1>
      <p className="text-xl mb-8 text-muted-foreground">
        {message || `Oops! The page you're looking for doesn't exist.`}
      </p>
      <Button asChild>
        <Link href="/">Go back home</Link>
      </Button>
    </div>
  );
}
